import './SalesforceSetupPanel.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Tag } from 'antd';
export const SalesforceOrganizationTypeTag = (props) => {
    const { isSandbox } = props;
    if (isSandbox === null || isSandbox === undefined) {
        return null;
    }
    return isSandbox ?
        React.createElement(Tag, { color: 'volcano' }, ADMIN_DASHBOARD_COPY.SANDBOX) :
        React.createElement(Tag, { color: 'blue' }, ADMIN_DASHBOARD_COPY.PRODUCTION);
};
